// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zB4K","colBig":"styles_colBig__1JSbz","colSmall":"styles_colSmall__hKFIU"};